<template>
    <div class="skeleton-wrap">
        <div class="skeleton" v-bind:class="classes" v-bind:style="{ width: this.getRandomInt(20, 100) + '%'}" v-if="variant == 'text'"></div>
        <div class="skeleton" v-bind:class="classes" v-else></div>
    </div>
</template>
<script>
    export default {
        name: 'Skeleton',
        components: {},
        props:  {
            variant: {
                type: String,
                default: 'text'
            },
            display: {
              type: String,
              default: ''
            }
        },
        data () {
            return {

            }
        },
        computed: {
          classes: function() {
            return this.display.length ? `small variant-${this.variant}` : `variant-${this.variant}`;
          }
        },
        mounted () {

        },
        methods: {
            getRandomInt(minNumber, maxNumber) {
                return Math.floor(Math.random() * (maxNumber - minNumber) + minNumber);
            }
        }
    }

</script>
<style src="./Skeleton.scss" scoped lang="scss"></style>

